import { css } from '@firebolt-dev/css'
import { cls } from '../core/cls'

export function UIEditorFieldBtns({ value, labels, onChange }) {
  return (
    <div
      className='fieldbtns'
      css={css`
        flex: 1;
        display: flex;
        align-items: center;
        gap: 4px;
        .fieldbtns-item {
          flex: 1;
          background: var(--bg4);
          border-radius: 5px;
          padding: 0 12px;
          height: 34px;
          display: flex;
          align-items: center;
          justify-content: center;
          color: #64647e;
          &.active {
            background: var(--bg5);
            color: white;
          }
          &:hover {
            cursor: pointer;
          }
        }
      `}
    >
      {value.map((active, idx) => (
        <div
          key={idx}
          className={cls('fieldbtns-item', { active })}
          onClick={() => {
            const newValue = value.slice()
            newValue[idx] = !active
            onChange(newValue)
          }}
        >
          <span>{labels[idx]}</span>
        </div>
      ))}
    </div>
  )
}
